/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import { CardOfTheDay } from "./modules/card-of-the-day";
import { Root } from "./modules/root";
import { ThreeCards } from "./modules/three-cards";

const elem = document.getElementById("root")!;
const app = (
	<StrictMode>
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<Root />}>
					{/* Redirect / → /card-of-the-day */}
					<Route index element={<Navigate to="/card-of-the-day" replace />} />

					<Route path="card-of-the-day" element={<CardOfTheDay />} />
					<Route path="three-cards" element={<ThreeCards />} />

					{/* Catch-all 404 */}
					<Route path="*" element={<div>Page not found</div>} />
				</Route>
			</Routes>
		</BrowserRouter>
	</StrictMode>
);

if (import.meta.hot) {
	// With hot module reloading, `import.meta.hot.data` is persisted.
	import.meta.hot.data.root ??= createRoot(elem);

	const root: ReturnType<typeof createRoot> = import.meta.hot.data.root;
	root.render(app);
} else {
	// The hot module reloading API is not available in production.
	createRoot(elem).render(app);
}
